module.exports = __webpack_public_path__ + "static/media/desodorante.4849fc50.jpeg";